import React from 'react'
import PropTypes from 'prop-types'
import { GridColumn } from 'semantic-ui-react'
import RegisteredFormField from '../../../common/RegisteredFormField'

const NameFields = ({ rootPath }) => {
  return <>
    <GridColumn width={6}>
      <RegisteredFormField
        path={`${rootPath}.lastName`}
        id='lastName'
        label='Last Name'
      />
    </GridColumn>
    <GridColumn width={6}>
      <RegisteredFormField
        path={`${rootPath}.firstName`}
        id='firstName'
        label='First Name'
      />
    </GridColumn>
    <GridColumn width={4}>
      <RegisteredFormField
        path={`${rootPath}.middleInitial`}
        id='middleInitial'
        label='Middle Initial'
        maxLength={1}
      />
    </GridColumn>
  </>
}

NameFields.propTypes = {
  /** Redux store object root path */
  rootPath: PropTypes.string.isRequired,
}

export default NameFields